import React, { useState } from 'react';

// components
import ChartTitleIntro from '../chartTitleIntro/chartTitleIntro';
import Chart2 from './chart2/chart2';
import Chart3 from './chart3/chart3';

// styles
import './chart2Wrapper.scss';
import AllQuestionButton from '../allQuestionsButton/allQuestionButton';
import Chart1 from './chart1/chart1';
import DataMethodLink from '../dataMethodLink/dataMethodLink';

const Chart2Wrapper = () => {
  const [selectedTab, setSelectedTab] = useState<number>(0);

  const handleChangeTab = (index: number) => {
    setSelectedTab(index);
  };

  return (
    <div className="chart2wrapper">
      <ChartTitleIntro number={2} title="Wie stark verändert der Staat die Einkommensverteilung durch Umverteilung?">
        In den folgenden interaktiven Grafiken sieht man das Ausmass der Umverteilung für die obersten Einkommensgruppen. Die Berechnung der
        Umverteilung erfolgt, indem die Einkommensanteile der Top-Verdiener vor und nach Steuern miteinander verglichen werden. Die Differenz
        entspricht der steuerlichen Umverteilung durch den Staat. Je grösser diese Differenz ist, desto höher ist die steuerliche Umverteilung.
        Beträgt beispielsweise der Einkommensanteil der Top-10%-Verdiener 35% vor Steuern und 31% nach Steuern, hat ihr Anteil am Gesamteinkommen
        durch die Besteuerung folglich um 4 Prozentpunkte abgenommen. Hier erfahren Sie mehr zu <DataMethodLink />.
      </ChartTitleIntro>

      <div className="charttabs">
        <div className="charttabs-tabs tabs-3">
          <div className={`charttabs-tab ${selectedTab === 0 ? 'active' : ''}`} onClick={() => handleChangeTab(0)}>
            2.1 EINKOMMENSANTEILE UND AUSMASS DER UMVERTEILUNG
          </div>
          <div className={`charttabs-tab ${selectedTab === 1 ? 'active' : ''}`} onClick={() => handleChangeTab(1)}>
            2.2 INTERKANTONALER VERGLEICH DER STEUERLICHEN UMVERTEILUNG
          </div>
          <div className={`charttabs-tab ${selectedTab === 2 ? 'active' : ''}`} onClick={() => handleChangeTab(2)}>
            2.3 ENTWICKLUNG DER STEUERLICHEN UMVERTEILUNG
          </div>
        </div>
        <div className="charttabs-content">
          <div className={`${selectedTab === 0 ? 'd-md-block' : 'd-md-none'}`}>
            <div className="charttabs-title d-md-none">2.1 EINKOMMENSANTEILE UND AUSMASS DER UMVERTEILUNG</div>
            <Chart1 />
          </div>
          <div className={`${selectedTab === 1 ? 'd-md-block' : 'd-md-none'}`}>
            <div className="charttabs-title d-md-none">2.2 INTERKANTONALER VERGLEICH DER STEUERLICHEN UMVERTEILUNG</div>
            <Chart2 />
          </div>
          <div className={`${selectedTab === 2 ? 'd-md-block' : 'd-md-none'}`}>
            <div className="charttabs-title d-md-none">2.3 ENTWICKLUNG DER STEUERLICHEN UMVERTEILUNG</div>
            <Chart3 />
          </div>
        </div>
      </div>
      <div className="d-md-none align-center">
        <AllQuestionButton />
      </div>
    </div>
  );
};

export default Chart2Wrapper;
